import { render, staticRenderFns } from "./clonedPEA.vue?vue&type=template&id=85a36ae4&scoped=true"
import script from "./clonedPEA.vue?vue&type=script&lang=js"
export * from "./clonedPEA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a36ae4",
  null
  
)

export default component.exports